import React from "react";
import { Stack } from "@gti-controls-v2/web-core";
import homePageStyles from "../../../common/styles/HomePage";

const Divider = () => {
    const styles =  homePageStyles;
    
    return (
        <Stack>
            <h2 style={styles.dividerContainer}>
                <span style={styles.divider}>
                    O
                </span>
            </h2>
        </Stack>
    );
};

export default Divider;